import MotifIcon from "@ey/motif-react-wrapper/Icon.js";
import React from "react";
import styled from "styled-components";
import { IconoirEmojiSad } from "@ey-xd/motif-icon";
import { labels } from "../../../util/utils";

const ErrorBoundary: React.FC = () => {
  return (
    <StyledErrorPage className="StyledErrorPage">
      <section className="icon">
        <MotifIcon src={IconoirEmojiSad} />
      </section>
      <section className="message">{labels.errorBoundaryMessage}</section>
    </StyledErrorPage>
  );
};

export default ErrorBoundary;

const StyledErrorPage = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: var(--neutrals-900);
  .icon {
    margin-bottom: var(--px-12);
    svg {
      color: var(--neutrals-900);
      fill: none;
      path {
        fill: none;
      }
    }
  }
  .message {
    font-size: var(--px-14);
    font-weight: 400;
    color: var(--neutrals-900);
  }
`;
